export const CourseCodesFilter = () => {
    return (courseCodes: string[]) => {
        if (courseCodes) {
            return courseCodes
                .map((courseCode) => {
                    if (courseCode.charAt(courseCode.length - 1) === "-") {
                        return courseCode.replace("-", "");
                    }
                    return courseCode.substring(0, courseCode.indexOf("-")) +
                        " (" + courseCode.substring(courseCode.indexOf("-") + 1, courseCode.length) + ")";
                })
                .join(", ");
        } else {
            return "";
        }

    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/assessment.course-code.filter.ts